module.exports = __webpack_public_path__ + "img/1.ff2cf3de.png";